import { useIntl } from 'react-intl'

import { KTIcon } from '../../../../../_metronic/helpers'
import { SmartTooltip } from '../../../../../components/SmartTooltip/SmartTooltip'
import { openFile } from '../../../../../utils/openFile'
import { MatchingFile } from '../../core/_models'
import { formatMskDateTime } from '../../routes/Dashboard/core/mskTime'

interface Props {
  history: MatchingFile[]
}

/**
 * Чеки, заменённые сотрудником, новые выше. По наведению — кто и когда (МСК) заменил каждый и его
 * статус на момент замены; клик по строке открывает файл.
 */
export const ReceiptHistory = ({ history }: Props) => {
  const intl = useIntl()

  if (history.length === 0) return null

  const content = (
    // A card in the page's theme, like the antifraud signal: the default dark chrome hides the links.
    <div
      className='d-flex flex-column gap-1'
      style={{
        backgroundColor: 'var(--bs-body-bg)',
        color: 'var(--bs-body-color)',
        border: '1px solid var(--bs-border-color)',
        borderRadius: 6,
        boxShadow: '0 2px 8px rgba(0,0,0,.15)',
        padding: '8px 12px',
      }}
    >
      <div className='fw-semibold mb-1'>Заменённые чеки</div>
      {history.map((file) => (
        <button
          key={file.id}
          type='button'
          className='btn btn-sm btn-link p-0 text-start'
          // Подсказка живёт в портале, но событие React всплывает по дереву компонентов — до
          // кликабельной строки таблицы (журнал пополнений раскрывает её по клику).
          onClick={(e) => {
            e.stopPropagation()
            openFile(file.url)
          }}
        >
          {file.replacedAt ? formatMskDateTime(file.replacedAt) : '—'}
          {' · '}
          {file.replacedBy ?? 'сотрудник не указан'}
          {' · '}
          {intl.formatMessage({ id: `receipt.status.${file.status}` })}
        </button>
      ))}
    </div>
  )

  return (
    <SmartTooltip content={content} closeDelayMs={300} bare>
      {/* not a row toggle: expandable rows open on a click anywhere outside their controls */}
      <span
        data-testid='receipt-history'
        role='button'
        className='d-inline-flex align-items-center gap-1 text-muted'
        tabIndex={0}
        style={{ cursor: 'help' }}
        onClick={(e) => e.stopPropagation()}
        onKeyDown={(e) => e.stopPropagation()}
      >
        <KTIcon className='fs-2' iconName='time' />
        <span className='fs-8'>{history.length}</span>
      </span>
    </SmartTooltip>
  )
}
